import Vue from 'vue';
import VueConfirmDialog from 'vue-confirm-dialog/src/index.js';

Vue.use(VueConfirmDialog);